module.exports = __webpack_public_path__ + "static/media/bg_kc_0.db25cc25.jpg";